export const CONTACT = {
  name: "IMPEXMILTRADE GMBH",
  street: "Hauptplatz 36",
  city: "A-8480 Mureck",
  country: "Österreich",
  phone: "+43 664 140 22 45",
  phoneHref: "+436641402245",
  fax: "+43 3472 26104",
  email: "office@impexmiltrade.com",
};

export const HOURS = [
  { day: "MO – FR", time: "09:00 – 12:00 · 15:00 – 18:00" },
  { day: "SA", time: "geschlossen" },
  { day: "SO / FEIERTAG", time: "geschlossen" },
];

export const BRANDS = [
  "GLOCK", "HECKLER & KOCH", "SIG SAUER", "STEYR ARMS", "BERETTA",
  "CZ", "SABATTI", "SAKO", "LEUPOLD", "AIMPOINT", "SCHMIDT & BENDER", "RWS",
];

export const CATEGORIES = [
  {
    code: "SEK-01",
    slug: "/waffen",
    title: "Waffen",
    tag: "Kurz- & Langwaffen",
    copy: "Pistolen, Revolver, Repetierer und Selbstladebüchsen führender Hersteller — geprüft, eingeschossen, verfügbar.",
    image: "https://images.unsplash.com/photo-1610165539774-791ae89d0574?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    code: "SEK-02",
    slug: "/munition",
    title: "Munition",
    tag: "Sport · Jagd · Behörde",
    copy: "Vom Kleinkaliber bis zur Großwildpatrone. Marken-Munition ab Lager, in jedem gängigen Kaliber.",
    image: "https://images.unsplash.com/photo-1551485913-b5dbedb723bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    code: "SEK-03",
    slug: "/zubehoer",
    title: "Zubehör",
    tag: "Optik · Führung · Pflege",
    copy: "Zielfernrohre, Rotpunktvisiere, Schalldämpfer, Holster und Waffenpflege — abgestimmt auf Ihr System.",
    image: "https://images.unsplash.com/photo-1610165539750-051008c3e799?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const FEATURED = {
  code: "REF · G17-GEN6",
  name: "Glock 17 Gen6",
  category: "Selbstladepistole",
  image: "https://images.unsplash.com/photo-1581955957646-b5a446b6100a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  copy: "Die Referenz unter den Dienstpistolen. Behördenerprobt, wartungsarm und in unserem Haus vorrätig — inklusive Beratung, Zubehör und Einschießen.",
  specs: [
    { k: "Kaliber", v: "9 × 19 mm" },
    { k: "Kapazität", v: "17 + 1" },
    { k: "Lauflänge", v: "114 mm" },
    { k: "Gewicht", v: "705 g" },
  ],
};

export const WAFFEN = [
  { code: "W-011", name: "Glock 17 Gen6", type: "Pistole", caliber: "9 × 19 mm", cap: "17+1", use: "Sport · Behörde" },
  { code: "W-024", name: "Heckler & Koch SFP9", type: "Pistole", caliber: "9 × 19 mm", cap: "15/17", use: "Sport · Dienst" },
  { code: "W-037", name: "SIG Sauer P320", type: "Pistole", caliber: "9 × 19 mm", cap: "17", use: "Sport · Behörde" },
  { code: "W-052", name: "Steyr AUG Z A3", type: "Selbstladebüchse", caliber: "5,56 × 45 mm", cap: "30", use: "Sport" },
  { code: "W-068", name: "Sabatti Saphire", type: "Repetierbüchse", caliber: ".308 Win", cap: "4", use: "Jagd · Sport" },
  { code: "W-079", name: "Beretta 92 FS", type: "Pistole", caliber: "9 × 19 mm", cap: "15", use: "Sport" },
  { code: "W-084", name: "Sako 85 Hunter", type: "Repetierbüchse", caliber: ".30-06 Sprg", cap: "5", use: "Jagd" },
  { code: "W-096", name: "CZ 457 Varmint", type: "Repetierbüchse", caliber: ".22 LR", cap: "5", use: "Sport · Training" },
];

export const MUNITION = [
  { code: "M-101", name: "9 × 19 mm Luger FMJ", use: "Sport / Training", weight: "124 gr" },
  { code: "M-118", name: ".223 Remington", use: "Sport", weight: "55 gr" },
  { code: "M-124", name: ".308 Winchester", use: "Jagd / Sport", weight: "150 gr" },
  { code: "M-132", name: ".30-06 Springfield", use: "Jagd", weight: "180 gr" },
  { code: "M-140", name: ".22 lfB (LR)", use: "Training", weight: "40 gr" },
  { code: "M-155", name: ".45 ACP FMJ", use: "Sport", weight: "230 gr" },
  { code: "M-162", name: "12/70 Schrot", use: "Jagd", weight: "32 g" },
  { code: "M-170", name: ".300 Win Mag", use: "Jagd / Fern", weight: "190 gr" },
];

export const ZUBEHOER = [
  { code: "Z-201", name: "Zielfernrohre", detail: "Tag- & Dämmerungsoptik führender Marken" },
  { code: "Z-214", name: "Rotpunktvisiere", detail: "Reflex- & Prismenvisiere für schnelle Zielaufnahme" },
  { code: "Z-223", name: "Schalldämpfer", detail: "Gehörschonende Systeme, passgenau montiert" },
  { code: "Z-235", name: "Holster & Tragesysteme", detail: "Kydex, Leder und Duty-Rigs" },
  { code: "Z-247", name: "Magazine & Ladehilfen", detail: "Ersatzmagazine und Speedloader" },
  { code: "Z-256", name: "Waffenpflege", detail: "Reinigungssets, Öle und Werkzeug" },
  { code: "Z-268", name: "Gehör- & Augenschutz", detail: "Aktive Kapselgehörschützer, Schießbrillen" },
  { code: "Z-279", name: "Waffenschränke", detail: "Zertifizierte Tresore nach EN 1143-1" },
];

export const LEISTUNGEN = [
  { code: "LST-01", title: "Fachberatung & Verkauf", copy: "Persönliche Beratung zu Kurz- und Langwaffen — vom ersten Sportgerät bis zum Behördenauftrag." },
  { code: "LST-02", title: "Import & Export", copy: "Abwicklung von Import, Export und Verbringung inkl. sämtlicher Genehmigungen und Dokumentation." },
  { code: "LST-03", title: "Behörden & Dienststellen", copy: "Belieferung von Behörden, Sicherheitsdiensten und Institutionen mit Waffen, Munition und Ausrüstung." },
  { code: "LST-04", title: "Jagd & Sport", copy: "Komplette Ausstattung für Jäger und Sportschützen — inklusive Einschießen und Optik-Montage." },
  { code: "LST-05", title: "Büchsenmacher-Betrieb", copy: "Eigene Werkstatt für Reparaturen, Instandsetzung, Anpassungen, Brünierung sowie Lauf- und Optikmontage — fachgerecht vom Büchsenmacher ausgeführt." },
  { code: "LST-06", title: "Waffenführerscheine", copy: "Wir stellen Waffenführerscheine inklusive der erforderlichen Schulung aus und verlängern bestehende Dokumente — inklusive Beratung zum gesamten Ablauf." },
];
